import { ProgressButtonProps, XProgressButton } from "./x-progress-button";

export const SearchButton = (props: ProgressButtonProps) => {
  return (
    <XProgressButton variant="contained" asyncAction={props.asyncAction}>
      {props.children ? props.children : `Tìm kiếm`}
    </XProgressButton>
  );
};
